import { render, staticRenderFns } from "./black.vue?vue&type=template&id=4b530d53&scoped=true&"
import script from "./black.vue?vue&type=script&lang=ts&"
export * from "./black.vue?vue&type=script&lang=ts&"
import style0 from "./black.vue?vue&type=style&index=0&id=4b530d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b530d53",
  null
  
)

export default component.exports